import { useEffect } from "react";
import { Collapse } from "@mantine/core";
import { useNavigate } from "react-router-dom";
import { useDisclosure } from "@mantine/hooks";
import {
  IconBell,
  IconMessageCircleSearch,
  IconAlertTriangle,
  IconPencil,
  IconLanguage,
  IconEye,
  IconSquareRoundedArrowUpFilled,
  IconSquareRoundedArrowDownFilled,
} from "@tabler/icons-react";
import { NavLink } from "./NavLink";
import { SectionHeader } from "./SectionHeader";
import { useIsPathActive } from "./hooks/useIsPathActive";

interface Props {
  chatNotification: number;
  helpNotification: number;
  orderDesignNotification: number;
  designReviewNotification: number;
}

export const NotificationsMenu = ({
  chatNotification,
  helpNotification,
  orderDesignNotification,
  designReviewNotification,
}: Props) => {
  const navigate = useNavigate();
  const isPathActive = useIsPathActive();

  const isProviderActive = isPathActive("/chats");
  const isHelpActive = isPathActive("/help-demands");
  const isOrderDesignActive = isPathActive("/notifications/order-design");
  const isDesignToReviewActive = isPathActive(
    "/notifications/design-to-review"
  );

  const isAnyChildActive =
    isProviderActive ||
    isHelpActive ||
    isOrderDesignActive ||
    isDesignToReviewActive;

  const [opened, { toggle, open }] = useDisclosure(isAnyChildActive);

  useEffect(() => {
    if (isAnyChildActive) {
      open();
    }
  }, [isAnyChildActive, open]);

  const collapseId = "navbar-notifications-menu";

  return (
    <>
      <SectionHeader
        title="NOTIFICATIONS"
        icon={<IconBell />}
        onClick={toggle}
        ariaExpanded={opened}
        ariaControls={collapseId}
        notificationNumber={
          chatNotification +
          helpNotification +
          orderDesignNotification +
          designReviewNotification
        }
        trailing={
          opened ? (
            <IconSquareRoundedArrowUpFilled />
          ) : (
            <IconSquareRoundedArrowDownFilled />
          )
        }
      />
      <Collapse expanded={opened}>
        <div
          id={collapseId}
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "5px",
            marginTop: "5px",
          }}
        >
          <NavLink
            title="PROVIDER"
            indent={1}
            onClick={() => navigate(`/chats?page=0`)}
            active={isProviderActive}
            notificationNumber={chatNotification}
            icon={<IconMessageCircleSearch />}
          />
          <NavLink
            title="HELP"
            indent={1}
            onClick={() => navigate(`/help-demands?page=0`)}
            active={isHelpActive}
            notificationNumber={helpNotification}
            icon={<IconAlertTriangle />}
          />
          <SectionHeader title="DESIGN" indent={1} icon={<IconPencil />} />
          <NavLink
            title="TO TRANSLATE"
            indent={2}
            onClick={() => navigate(`/notifications/order-design?page=0`)}
            active={isOrderDesignActive}
            notificationNumber={orderDesignNotification}
            icon={<IconLanguage />}
          />
          <NavLink
            title="TO BE REVIEWED"
            indent={2}
            onClick={() => navigate(`/notifications/design-to-review`)}
            active={isDesignToReviewActive}
            notificationNumber={designReviewNotification}
            icon={<IconEye />}
          />
        </div>
      </Collapse>
    </>
  );
};
